export default __webpack_public_path__ + "static/media/infografika-bf.218856ec.svg";